__turbopack_context__.v({
  "avatar": "MentionDropdown-module-scss-module__VtZmuW__avatar",
  "avatarPlaceholder": "MentionDropdown-module-scss-module__VtZmuW__avatarPlaceholder",
  "dropdown": "MentionDropdown-module-scss-module__VtZmuW__dropdown",
  "empty": "MentionDropdown-module-scss-module__VtZmuW__empty",
  "info": "MentionDropdown-module-scss-module__VtZmuW__info",
  "item": "MentionDropdown-module-scss-module__VtZmuW__item",
  "list": "MentionDropdown-module-scss-module__VtZmuW__list",
  "loading": "MentionDropdown-module-scss-module__VtZmuW__loading",
  "loadingSpinner": "MentionDropdown-module-scss-module__VtZmuW__loadingSpinner",
  "name": "MentionDropdown-module-scss-module__VtZmuW__name",
  "selected": "MentionDropdown-module-scss-module__VtZmuW__selected",
  "spin": "MentionDropdown-module-scss-module__VtZmuW__spin",
  "team": "MentionDropdown-module-scss-module__VtZmuW__team",
});
